<template>
  <div
    v-if="featuredCategories.length"
    class="carousel-slider"
  >
    <ul
      id="carousel-category__controls"
      class="carousel__controls"
      aria-label="carousel-categories Navigation"
      tabindex="0"
    >
      <li
        class="carousel__control carousel__control--prev"
        data-controls="prev"
        aria-controls="customize"
        tabindex="-1"
      >
        <img
          src="/img/icon/caret-left-blue.svg"
          alt="Previous"
          width="16"
          height="28"
          class="carousel__control-image"
        >
      </li>
      <li
        class="carousel__control carousel__control--next"
        data-controls="next"
        aria-controls="customize"
        tabindex="-1"
      >
        <img
          src="/img/icon/caret-right-blue.svg"
          alt="Next"
          width="16"
          height="28"
          class="carousel__control-image"
        >
      </li>
    </ul>

    <carousel
      v-if="featuredCategories.length"
      v-bind="carouselOptions"
    >
      <div
        v-for="featuredCategory in featuredCategories"
        :key="featuredCategory.id"
        class="carousel-slider__item"
      >
        <content-loader
          v-if="!myData"
          :speed="3"
          :animate="true"
          class="content-loader"
          width="485"
          height="305"
        />
        <a
          v-else
          :href="featuredCategory.category.route"
          :aria-label="featuredCategory.category.name"
        >
          <div class="carousel-slider__inner">
            <div class="carousel-slider__image-container">
              <img
                :src="`/storage/${featuredCategory.image}`"
                :alt="featuredCategory.category.name"
                class="carousel-slider__image"
                width="485"
                height="305"
              >
            </div>
            <div class="carousel-slider__text-overlay">
              <h3
                class="carousel-slider__heading-overlay carousel-slider__heading-overlay--h3"
              >
                {{ featuredCategory.category.name }}
              </h3>
            </div>
          </div>
        </a>
      </div>
    </carousel>
  </div>
</template>

<script>
import VueTinySlider from 'vue-tiny-slider';
import { ContentLoader } from 'vue-content-loader';
import '../../scss/addons/_tinyslider.scss';

export default {
  components: {
    carousel: VueTinySlider,
    ContentLoader,
  },
  props: {
    apiRoutes: { required: true, type: Object },
  },
  data() {
    return {
      myData: null,
      featuredCategories: [],
      carouselOptions: {
        items: 1,
        gutter: 10,
        loop: false,
        rewind: true,

        mouseDrag: true,
        controlsContainer: '#carousel-category__controls',
        responsive: {
          400: {
            items: 1,
            gutter: 10,
          },
          600: {
            items: 2,
            gutter: 16,
          },
          1000: {
            items: 3,
            gutter: 16,
          },
          1200: {
            gutter: 32,
          },
        },
      },
    };
  },
  mounted() {
    this.loadCategories();
    setTimeout(() => {
      this.myData = 'Categories';
    }, 3000);
  },
  methods: {
    requestCategories() {
      const request = axios.get(this.apiRoutes.featuredCategories);
      return request;
    },
    loadCategories() {
      this.requestCategories()
        .then((response) => {
          this.featuredCategories = response.data.data;
          this.loading = false;
        })
        .catch((error) => {
          let response = error.response;
          this.loading = false;
          console.log(response);
        });
    },
  },
};
</script>
